import { forwardRef } from 'react'

import { IconButton, IconButtonProps } from '../IconButton'
import { CloseIcon } from '../../icons'

export type CloseButtonProps = Omit<IconButtonProps, 'children'>

export const CloseButton = forwardRef<'button', CloseButtonProps>(
  (props, ref) => (
    <IconButton ref={ref} aria-label='close' variant='plain' {...props}>
      <CloseIcon color='currentColor' />
    </IconButton>
  )
)
